import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import Select from 'react-select';
import { API_URL } from '..';

const ViewStaffLayer = ({ data }) => {
    const [activeTab, setActiveTab] = useState('personal');
    const [isEditMode, setIsEditMode] = useState(false);
    const [formValues, setFormValues] = useState({
        name: data.name ,
        email: data.email ,
        phone: data.phone ,
        role: { value: data.role || 'electrician', label: data.role || 'Electrician' },
        status: data.status || 'active'
    });
    const [passwordForm, setPasswordForm] = useState({
        newPassword: '',
        confirmPassword: ''
    });
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState({
        status: false,
        reason: '',
        desc: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const roleOptions = [
        
        { value: 'admin', label: 'Admin' },
        { value: 'user', label: 'User' }
    ];

    const validatePersonalInfo = () => {
        const newErrors = {};
        if (!formValues.name) newErrors.name = 'Name is required';
        if (!formValues.email || !/\S+@\S+\.\S+/.test(formValues.email)) newErrors.email = 'Valid email is required';
        if (!formValues.phone) newErrors.phone = 'Phone is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validatePassword = () => {
        const newErrors = {};
        if (!passwordForm.newPassword) newErrors.newPassword = 'Current password is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handlePersonalInfoSubmit = async (e) => {
        e.preventDefault();
        if (!validatePersonalInfo()) return;

        setIsSubmitting(true);
        try {
            const response = await fetch(`${API_URL}/api/user/update-user/${data.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: formValues.name,
                    email: formValues.email,
                    phone: formValues.phone,
                    role: formValues.role.value,
                    status: formValues.status
                })
            });
            const responseData = await response.json();
            if (response.status === 200) {
                setMessage({ status: true, reason: 'success', desc: 'Staff information updated successfully' });
                setIsEditMode(false);
                window.history.back();
                
            } else {
                throw new Error(responseData.message || 'Failed to update staff information');
            }
        } catch (error) {
            setMessage({ status: true, reason: 'error', desc: `Failed to update staff: ${error.message}` });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        if (!validatePassword()) return;

        setIsSubmitting(true);
        try {
            const response = await fetch(`${API_URL}/api/user/change-password/${data.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ old_password: passwordForm.newPassword,  new_password : passwordForm.confirmPassword  })
            });
            const responseData = await response.json();
            if (response.status === 200) {
                setMessage({ status: true, reason: 'success', desc: 'Password updated successfully' });
                setPasswordForm({ newPassword: '', confirmPassword: '' });
            } else {
                throw new Error(responseData.message || 'Failed to update password');
            }
        } catch (error) {
            setMessage({ status: true, reason: 'error', desc: `Failed to update password: ${error.message}` });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleInputChange = (field, value) => {
        setFormValues({ ...formValues, [field]: value });
        setErrors({ ...errors, [field]: '' });
    };

    const handlePasswordChange = (field, value) => {
        setPasswordForm({ ...passwordForm, [field]: value });
        setErrors({ ...errors, [field]: '' });
    };

    const toggleEditMode = () => {
        setFormValues({
            name: data.name ,
            email: data.email ,
            phone: data.phone ,
            role: { value: data.role || 'electrician', label: data.role || 'Electrician' },
            status: data.status || 'active'
        })
        setIsEditMode(!isEditMode);
        setErrors({});
        setMessage({ status: false, reason: '', desc: '' });
        if (isEditMode) {
            // Reset form to original data when exiting edit mode
            setFormValues({
                name: data.name || '',
                email: data.email || '',
                phone: data.phone || '',
                role: { value: data.role || 'electrician', label: data.role || 'Electrician' },
                status: data.status || 'active'
            });
        }
    };

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-12">
                    <div className="card shadow-sm border-0">
                        <div className="card-header bg-white">
                            <h6 className="h6 mb-0">View Staff</h6>
                        </div>
                        <div className="card-body">
                            {/* Tabs */}
                            <ul className="nav nav-tabs mb-4" role="tablist">
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'personal' ? 'active' : ''}`}
                                        onClick={() => {
                                            setActiveTab('personal');
                                            setMessage({ status: false, reason: '', desc: '' });
                                        }}
                                    >
                                        Personal Information
                                    </button>
                                </li>
                               
                            </ul>

                            {/* Message Alert */}
                            {message.status && (
                                <div className={`alert alert-${message.reason === 'error' ? 'danger' : 'success'} alert-dismissible fade show mb-4`} role="alert">
                                    {message.desc}
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setMessage({ ...message, status: false })}
                                        aria-label="Close"
                                    ></button>
                                </div>
                            )}

                            {/* Personal Information Tab */}
                            {activeTab === 'personal' && (
                                <div className="p-3 rounded">
                                    <h2 className="h6 mb-4">Personal Information</h2>
                                    {isEditMode ? (
                                        <form onSubmit={handlePersonalInfoSubmit}>
                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <label htmlFor="name" className="form-label fw-bold">Name</label>
                                                    <input
                                                        type="text"
                                                        id="name"
                                                        value={formValues.name}
                                                        onChange={(e) => handleInputChange('name', e.target.value)}
                                                        className={`form-control form-control-lg ${errors.name ? 'is-invalid' : ''}`}
                                                    />
                                                    <div className="form-text">Enter the staff's full name.</div>
                                                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="email" className="form-label fw-bold">Email</label>
                                                    <input
                                                        type="email"
                                                        id="email"
                                                        value={formValues.email}
                                                        onChange={(e) => handleInputChange('email', e.target.value)}
                                                        className={`form-control form-control-lg ${errors.email ? 'is-invalid' : ''}`}
                                                    />
                                                    <div className="form-text">e.g., staff@example.com</div>
                                                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="phone" className="form-label fw-bold">Phone</label>
                                                    <input
                                                        type="text"
                                                        id="phone"
                                                        value={formValues.phone}
                                                        onChange={(e) => handleInputChange('phone', e.target.value)}
                                                        className={`form-control form-control-lg ${errors.phone ? 'is-invalid' : ''}`}
                                                    />
                                                    <div className="form-text">e.g., +44 123 456 7890</div>
                                                    {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                                                </div>
                                                
                                             
                                                
                                            </div>
                                            <div className="d-flex justify-content-end mt-5 gap-3">
                                                <button
                                                    type="button"
                                                    onClick={toggleEditMode}
                                                    className="btn btn-secondary btn-lg"
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-success btn-lg"
                                                    disabled={isSubmitting}
                                                >
                                                    <Icon icon="simple-line-icons:check" className="me-2" />
                                                    {isSubmitting ? 'Saving...' : 'Save Changes'}
                                                </button>
                                            </div>
                                        </form>
                                    ) : (
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label fw-bold">Name</label>
                                                <input
                                                    type="text"
                                                    value={data.name}
                                                    className="form-control form-control-lg"
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-bold">Email</label>
                                                <input
                                                    type="email"
                                                    value={data.email}
                                                    className="form-control form-control-lg"
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-bold">Phone</label>
                                                <input
                                                    type="text"
                                                    value={data.phone}
                                                    className="form-control form-control-lg"
                                                    readOnly
                                                />
                                            </div>
                                         
                                            <div className="col-md-6">
                                                <label className="form-label fw-bold">Created At</label>
                                                <input
                                                    type="text"
                                                    value={new Date(data.createdAt).toLocaleString()}
                                                    className="form-control form-control-staff form-control-lg"
                                                    readOnly
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-bold">Updated At</label>
                                                <input
                                                    type="text"
                                                    value={new Date(data.updatedAt).toLocaleString()}
                                                    className="form-control form-control-staff form-control-lg"
                                                    readOnly
                                                />
                                            </div>
                                           
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Password Tab */}
                            {activeTab === 'password' && (
                                <div className="p-3 rounded">
                                    <h2 className="h6 mb-4">Change Password</h2>
                                    <form onSubmit={handlePasswordSubmit}>
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label htmlFor="newPassword" className="form-label fw-bold">Current Password</label>
                                                <input
                                                    type="password"
                                                    id="newPassword"
                                                    value={passwordForm.newPassword}
                                                    onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
                                                    className={`form-control form-control-lg ${errors.newPassword ? 'is-invalid' : ''}`}
                                                />
                                                <div className="form-text">Minimum 6 characters.</div>
                                                {errors.newPassword && <div className="invalid-feedback">{errors.newPassword}</div>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="confirmPassword" className="form-label fw-bold">New Password</label>
                                                <input
                                                    type="password"
                                                    id="confirmPassword"
                                                    value={passwordForm.confirmPassword}
                                                    onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
                                                    className={`form-control form-control-lg ${errors.confirmPassword ? 'is-invalid' : ''}`}
                                                />
                                                {/* <div className="form-text">Must match the new password.</div> */}
                                                {/* {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>} */}
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-end mt-5">
                                            <button
                                                type="submit"
                                                className="btn btn-success btn-lg"
                                                disabled={isSubmitting}
                                            >
                                                <Icon icon="simple-line-icons:check" className="me-2" />
                                                {isSubmitting ? 'Updating...' : 'Update Password'}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewStaffLayer;